const TIERS = {
  1: { label: "🥇", className: "bg-yellow-400/20 text-yellow-300 border border-yellow-400/40" },
  2: { label: "🥈", className: "bg-slate-400/20 text-slate-300 border border-slate-400/40" },
  3: { label: "🥉", className: "bg-orange-400/20 text-orange-300 border border-orange-400/40" },
};

const RankBadge = ({ rank }) => {
  const tier = TIERS[rank];
  if (tier) {
    return (
      <span className={`inline-flex h-8 w-8 items-center justify-center rounded-full text-base ${tier.className}`}>
        {tier.label}
      </span>
    );
  }
  return (
    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/5 text-xs font-semibold text-white/50">
      {rank}
    </span>
  );
};

export default RankBadge;
